import { TooltipButton } from 'components';
import { EditOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { Drawers } from 'app/types/drawer';
import { useOpenDrawerHandler } from 'hooks/useOpenDrawerHandler';

type EditProps = {
  id: number,
  minimized?: boolean,
}

const Edit = ({ id, minimized }: EditProps) => {
  const { t } = useTranslation();

  const handleClick = useOpenDrawerHandler({ key: Drawers.EDIT_USER, props: { id } });

  return (
    <TooltipButton
      key={id}
      title={t('common.edit')}
      minimized={minimized}
      buttonProps={{
        icon: <EditOutlined />,
        type: 'link',
        onClick: handleClick,
      }}
    />
  );
};

export default Edit;